import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';
import { useTrackingEvent } from 'src/services/useTrackingEvent';

import { ToneOfVoicePopup } from './ToneOfVoicePopup';

export const TONE_OF_VOICE_POPUP = Symbol('TONE_OF_VOICE');

export const useToneOfVoicePopup = () => {
  const popups = usePopups();
  const trackEvent = useTrackingEvent();

  useEffectOnce(() => {
    popups.registerPopup(TONE_OF_VOICE_POPUP, ToneOfVoicePopup);
  });

  return useCallback(
    ({
      brandVoice,
      toneOfVoice,
      onCreateCustomModel,
      page,
      shouldActiveDraftMode,
      shouldActivateManualStep,
      shouldActivateLastStep,
      shouldOnlyTrain,
      language,
    }) => {
      return new Promise((resolve) => {
        trackEvent(events.TONE_OF_VOICE.toneOfVoicePopupShown, {
          page,
        });
        popups.openPopup(TONE_OF_VOICE_POPUP, {
          brandVoice,
          toneOfVoice,
          onCreateCustomModel,
          page,
          shouldActiveDraftMode,
          shouldActivateManualStep,
          shouldActivateLastStep,
          shouldOnlyTrain,
          language: language ? language : brandVoice?.language,
          onClose: (result) => {
            popups.closePopup(TONE_OF_VOICE_POPUP);
            resolve(result);
          },
        });
      });
    },
    [popups, trackEvent]
  );
};
